import { Pipe, PipeTransform } from '@angular/core';

// Moment
import * as moment from 'moment';

@Pipe({
  name: 'moment'
})
export class MomentPipe implements PipeTransform {

  // Transform
  public transform(value: any, args?: string[]): any {
    const language: string = typeof args[0] === 'undefined' ? 'en' : args[0].split('-')[0];

    if (args.length > 1) {
      return moment(value).locale(language).format(args[1]);
    } else {
      return moment(value * 1000).locale(language).fromNow();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/moment/moment.pipe.ts